module.exports = __webpack_public_path__ + "media/images/menu/equuleus-9afb780bd76529c3e97b8b7830069471.jpg";